/**
 * Matches the "kind" JSON type discriminator sent by the API for message parts.
 */
export enum MessagePartKind {
    SuggestMemory = "suggestMemory",
}
